// extracted by mini-css-extract-plugin
module.exports = {"notificationBox":"_2lQ2R_","roundedBox":"cUBejW","notificationBoxRedesign":"_3zRgVs"};